import React from 'react';
import { styles } from '../AuthWrapper.styles';
import type { AuthFormState } from '../../hooks/useAuthForm';

const ResetConfirmForm: React.FC<{ form: AuthFormState }> = ({ form }) => {
  const {
    email,
    verificationCode,
    setVerificationCode,
    newPassword,
    setNewPassword,
    confirmNewPassword,
    setConfirmNewPassword,
    isSubmitting,
    handleConfirmResetPassword,
    setAuthMode,
  } = form;

  return (
    <form onSubmit={handleConfirmResetPassword} style={styles.form}>
      <p style={styles.confirmText}>
        We've sent a verification code to <strong>{email}</strong>. Enter the code and your new password below.
      </p>
      <div style={styles.formGroup}>
        <label style={styles.label} htmlFor="verificationCode">Verification Code</label>
        <input
          id="verificationCode"
          type="text"
          value={verificationCode}
          onChange={(e) => setVerificationCode(e.target.value)}
          placeholder="Enter 6-digit code"
          required
          maxLength={6}
          style={styles.input}
          disabled={isSubmitting}
        />
      </div>
      <div style={styles.formGroup}>
        <label style={styles.label} htmlFor="newPassword">New Password</label>
        <input
          id="newPassword"
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          placeholder="Enter new password (min 8 characters)"
          required
          style={styles.input}
          disabled={isSubmitting}
        />
      </div>
      <div style={styles.formGroup}>
        <label style={styles.label} htmlFor="confirmNewPassword">Confirm New Password</label>
        <input
          id="confirmNewPassword"
          type="password"
          value={confirmNewPassword}
          onChange={(e) => setConfirmNewPassword(e.target.value)}
          placeholder="Confirm new password"
          required
          style={styles.input}
          disabled={isSubmitting}
        />
      </div>
      <button
        type="submit"
        style={{
          ...styles.button,
          ...(isSubmitting ? styles.buttonDisabled : {}),
        }}
        disabled={isSubmitting}
      >
        {isSubmitting ? 'Resetting password...' : 'Reset Password'}
      </button>
      <button
        type="button"
        style={styles.linkButton}
        onClick={() => {
          setAuthMode('signin');
        }}
      >
        Back to Sign In
      </button>
    </form>
  );
};

export default ResetConfirmForm;
